import React, { useState } from 'react';
import * as LucideIcons from 'lucide-react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import SyndicateInfoModal from './SyndicateInfoModal';

const InfoStep = ({ icon, title, children, index }) => {
    const Icon = LucideIcons[icon];
    return (
        <motion.div 
            className="flex flex-col items-center text-center p-4 bg-gray-800/50 rounded-lg"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0, transition: { delay: 0.2 * index } }}
        >
            <div className="p-3 bg-purple-500/20 rounded-full mb-3">
                <Icon size={32} className="text-purple-300" />
            </div>
            <h4 className="font-bold text-lg text-white mb-1">{title}</h4>
            <p className="text-sm text-gray-400">{children}</p>
        </motion.div>
    );
};

const VisualLotteryGuide = ({ onClose }) => {
    const { t } = useTranslation();
    const [showSyndicateInfo, setShowSyndicateInfo] = useState(false);

    return (
        <>
            <div 
                className="fixed inset-0 bg-black/80 backdrop-blur-md flex items-center justify-center z-50 p-4"
                onClick={onClose}
            >
                <motion.div 
                    className="bg-gray-900/80 p-6 rounded-xl shadow-glow max-w-5xl w-full border border-purple-500/50"
                    onClick={e => e.stopPropagation()}
                    initial={{ scale: 0.9, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    exit={{ scale: 0.9, opacity: 0 }}
                >
                    <div className="flex justify-between items-center mb-6">
                        <h2 className="text-2xl font-bold text-white font-playfair">{t('visualLotteryGuide.title')}</h2>
                        <button onClick={onClose} className="text-gray-400 hover:text-white">
                            <LucideIcons.X size={24} />
                        </button>
                    </div>
                    
                    <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
                        <InfoStep icon="Ticket" title={t('visualLotteryGuide.step1.title')} index={1}>
                            {t('visualLotteryGuide.step1.description')}
                        </InfoStep>
                        <InfoStep icon="Gem" title={t('visualLotteryGuide.step2.title')} index={2}>
                            {t('visualLotteryGuide.step2.description')}
                        </InfoStep>
                        <InfoStep icon="Gift" title={t('visualLotteryGuide.step3.title')} index={3}>
                            {t('visualLotteryGuide.step3.description')}
                        </InfoStep>
                        <InfoStep icon="Trophy" title={t('visualLotteryGuide.step4.title')} index={4}>
                            {t('visualLotteryGuide.step4.description')}
                        </InfoStep>
                        <InfoStep icon="Users" title={t('visualLotteryGuide.step5.title')} index={5}>
                            {t('visualLotteryGuide.step5.description')}
                            <button onClick={() => setShowSyndicateInfo(true)} className="text-cyan-400 hover:text-cyan-300 font-bold mt-2">
                                {t('visualLotteryGuide.learnMore')}
                            </button>
                        </InfoStep>
                    </div>

                    <div className="text-center mt-6">
                         <button onClick={onClose} className="px-6 py-2 bg-purple-600 text-white font-bold rounded-full hover:bg-purple-700 transition-colors">
                            {t('visualLotteryGuide.gotIt')}
                        </button>
                    </div>
                </motion.div>
            </div>
            {showSyndicateInfo && <SyndicateInfoModal onClose={() => setShowSyndicateInfo(false)} />}
        </>
    );
};

export default VisualLotteryGuide;
